// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thirdpartylogisticcompany() {



const cardData = {


    keyword: "Third Party Logistics Company in India",

    headingDescription: "SSK Logistic supports businesses searching for a Third Party Logistics Company in India with coordinated logistics services covering transportation, freight movement, cargo distribution, warehouse support, and supply chain operations. Third-party logistics allows businesses to coordinate selected or multiple logistics activities through an external logistics partner instead of managing every transportation and distribution function internally. SSK Logistic provides practical 3PL support for manufacturers, distributors, retailers, wholesalers, commercial organizations, and industrial businesses that need organized movement of goods across India. From 3PL transportation and freight services to warehousing, distribution, cargo movement, and end-to-end logistics coordination, the service approach is designed to connect different stages of business supply chains while supporting recurring and destination-based logistics requirements.",

    topPlaces: [
        {
            title: "Pune to Delhi",
            description: "Pune to Delhi is an important interstate corridor for businesses managing nationwide distribution and supply chain movement. SSK Logistic supports 3PL transportation requirements between Pune-based operations and Delhi-area warehouses, distributors, commercial facilities, and destination markets."
        },
        {
            title: "Bengaluru",
            description: "Bengaluru is a major commercial and technology-driven business market where companies may require coordinated transportation, warehousing, and distribution support. SSK Logistic assists businesses with 3PL logistics movement connecting suppliers, warehouses, business facilities, and customers."
        },
        {
            title: "Pune to Ahmedabad",
            description: "Pune to Ahmedabad connects two important western Indian commercial and industrial markets. SSK Logistic provides third-party logistics support for businesses requiring freight transportation, distribution movement, warehouse transfers, and recurring cargo connectivity along this route."
        },
        {
            title: "Hyderabad",
            description: "Hyderabad serves as an important southern and central commercial market for businesses distributing products and industrial goods. SSK Logistic supports 3PL transportation and distribution requirements connecting Pune and other origin locations with Hyderabad-area warehouses and business destinations."
        },
        {
            title: "Pune to Kolkata",
            description: "Pune to Kolkata provides long-distance connectivity between western and eastern Indian markets. SSK Logistic assists businesses with third-party logistics transportation for commercial freight, distribution cargo, warehouse transfers, and recurring supply chain movement."
        },
        {
            title: "Chennai",
            description: "Chennai is a major southern commercial and industrial market requiring regular movement of products, materials, and distribution cargo. SSK Logistic supports 3PL transportation and logistics coordination for businesses connecting their supply chain operations with Chennai and surrounding markets."
        },
        {
            title: "Pune to Jaipur",
            description: "Pune to Jaipur connects western India with Rajasthan's commercial and distribution network. SSK Logistic provides 3PL freight and transportation support for businesses managing commercial goods, industrial cargo, warehouse transfers, and destination-based distribution."
        },
        {
            title: "Kochi",
            description: "Kochi provides access to important southern markets and can form part of wider national distribution networks. SSK Logistic supports third-party logistics requirements involving transportation, cargo movement, distribution coordination, and connections between warehouses and commercial destinations."
        },
        {
            title: "Pune to Lucknow",
            description: "Pune to Lucknow is a long-distance corridor supporting movement between western India and northern commercial markets. SSK Logistic assists businesses with 3PL transportation planning for recurring freight, distribution consignments, warehouse transfers, and supply chain cargo."
        },
        {
            title: "Noida",
            description: "Noida is an important commercial and industrial market within the National Capital Region where businesses may require organized 3PL logistics support. SSK Logistic coordinates transportation and distribution requirements connecting warehouses, suppliers, commercial facilities, and customer destinations."
        }
    ],

    "services": [
        {
            "name": "third party logistics company india",
            "description": "Businesses searching for a third party logistics company india can use SSK Logistic for coordinated transportation, freight, distribution, and warehouse-related logistics support. The service model helps businesses manage selected or multiple logistics activities through an external transportation and supply chain partner."
        },
        {
            "name": "3pl logistics company india",
            "description": "A 3pl logistics company india can support businesses that need external coordination for transportation, warehousing, distribution, and freight operations. SSK Logistic provides practical 3PL assistance designed around recurring shipments, destination networks, warehouse requirements, and supply chain movement."
        },
        {
            "name": "third party logistics services india",
            "description": "Third party logistics services india help businesses outsource selected logistics functions such as transportation, cargo movement, warehousing, and distribution. SSK Logistic coordinates these activities according to business requirements, shipment patterns, operational locations, and destination markets."
        },
        {
            "name": "3pl logistics services india",
            "description": "3pl logistics services india cover different stages of commercial and industrial logistics operations, including freight movement, transportation, warehousing, and distribution. SSK Logistic supports businesses with coordinated logistics activities that can be integrated into their existing supply chain."
        },
        {
            "name": "third party logistics provider india",
            "description": "As a third party logistics provider india, SSK Logistic assists businesses with external logistics coordination for transportation, distribution, cargo movement, and warehouse-related requirements. Services can be structured around shipment volume, business locations, recurring routes, and operational priorities."
        },
        {
            "name": "3pl service provider india",
            "description": "A 3pl service provider india supports businesses that need professional assistance with logistics activities outside their core operations. SSK Logistic provides transportation and distribution coordination for companies managing commercial, industrial, warehouse, and supply chain movement across different destinations."
        },
        {
            "name": "best 3pl logistics company india",
            "description": "Businesses researching a best 3pl logistics company india may be comparing providers based on transportation coverage, warehousing support, distribution capabilities, responsiveness, and supply chain coordination. SSK Logistic offers practical 3PL services covering freight movement, cargo transportation, distribution, and logistics planning."
        },
        {
            "name": "top 3pl companies india",
            "description": "Businesses researching top 3pl companies india often need a provider capable of coordinating multiple logistics functions across different locations. SSK Logistic supports third-party logistics requirements through transportation, freight, cargo, warehouse, and distribution coordination."
        },
        {
            "name": "leading 3pl companies india",
            "description": "Companies comparing leading 3pl companies india may look for logistics partners capable of handling recurring transportation and distribution requirements. SSK Logistic provides structured 3PL support for businesses requiring freight movement, warehouse coordination, cargo transportation, and supply chain assistance."
        },
        {
            "name": "3pl transportation services india",
            "description": "3pl transportation services india help businesses outsource transportation requirements while maintaining organized movement between suppliers, warehouses, facilities, distributors, and customers. SSK Logistic coordinates road freight and cargo transportation according to route, shipment volume, and delivery requirements."
        },
        {
            "name": "3pl warehousing services india",
            "description": "3pl warehousing services india support businesses that need external assistance with storage-related logistics and movement between warehouses and other supply chain locations. SSK Logistic provides warehouse transportation and logistics coordination connected with broader distribution requirements."
        },
        {
            "name": "3pl supply chain services india",
            "description": "3pl supply chain services india help businesses coordinate multiple logistics activities through an external partner. SSK Logistic supports transportation, distribution, freight movement, warehouse transfers, and related supply chain logistics according to the operational structure of each business."
        },
        {
            "name": "third party logistics provider pune",
            "description": "Businesses looking for a third party logistics provider pune can use SSK Logistic for transportation, distribution, freight, and warehouse-related logistics support. Services can connect Pune-based manufacturing and commercial operations with suppliers, warehouses, distributors, and destinations across India."
        },
        {
            "name": "3pl logistics provider pune",
            "description": "A 3pl logistics provider pune supports businesses requiring external coordination of transportation and distribution activities. SSK Logistic provides practical logistics support for Pune-based companies managing recurring freight, warehouse transfers, commercial distribution, and interstate supply chain requirements."
        },
        {
            "name": "end to end 3pl services india",
            "description": "End to end 3pl services india involve coordination across several logistics stages, from transportation and freight movement to warehousing and distribution. SSK Logistic supports businesses seeking connected logistics assistance across multiple points in their supply chain."
        },
        {
            "name": "third party logistics solutions india",
            "description": "Third party logistics solutions india can help businesses outsource transportation, warehousing, distribution, and freight activities according to their operational requirements. SSK Logistic provides flexible logistics coordination designed around shipment frequency, destination networks, cargo requirements, and supply chain needs."
        },
        {
            "name": "3pl freight services india",
            "description": "3pl freight services india support businesses with organized movement of larger commercial and industrial consignments across multiple destinations. SSK Logistic coordinates freight transportation, route planning, pickup arrangements, and delivery movement as part of broader third-party logistics operations."
        },
        {
            "name": "3pl cargo transportation india",
            "description": "3pl cargo transportation india enables businesses to outsource cargo movement while maintaining a coordinated logistics structure. SSK Logistic supports commercial and industrial cargo transportation between suppliers, warehouses, distribution centers, and destination markets across India."
        },
        {
            "name": "3pl distribution services india",
            "description": "3pl distribution services india help businesses manage product movement from warehouses and operational facilities toward distributors, retailers, and customers. SSK Logistic provides transportation and distribution coordination designed for recurring commercial and industrial supply chain requirements."
        },
        {
            "name": "3pl warehouse management india",
            "description": "3pl warehouse management india involves external coordination of warehouse-related logistics activities and movement between storage and distribution points. SSK Logistic supports businesses with transportation and warehouse transfer requirements connected with their wider supply chain operations."
        },
        {
            "name": "reliable 3pl company india",
            "description": "Businesses searching for a reliable 3pl company india often require consistent transportation, distribution, freight, and warehouse coordination. SSK Logistic focuses on structured logistics planning and recurring movement support for companies managing multi-location supply chain requirements."
        },
        {
            "name": "professional 3pl logistics provider india",
            "description": "A professional 3pl logistics provider india can help businesses coordinate logistics functions without managing every transportation activity internally. SSK Logistic provides organized third-party logistics support covering freight movement, cargo transportation, distribution, and warehouse-related requirements."
        },
        {
            "name": "3pl logistics partner india",
            "description": "A 3pl logistics partner india can support businesses with recurring logistics activities across different suppliers, warehouses, distribution points, and customer markets. SSK Logistic coordinates transportation and related logistics requirements according to business operations and destination networks."
        },
        {
            "name": "3pl transportation company india",
            "description": "A 3pl transportation company india supports businesses requiring external management of road freight and cargo movement. SSK Logistic provides transportation coordination for commercial and industrial shipments across regional and interstate routes as part of broader third-party logistics services."
        },
        {
            "name": "third party logistics solutions provider india",
            "description": "A third party logistics solutions provider india helps businesses coordinate outsourced logistics functions according to their supply chain structure. SSK Logistic supports transportation, freight, distribution, cargo, and warehouse-related requirements through flexible third-party logistics coordination."
        }
    ],

    "tableData": [
        ["third party logistics company india", "3pl logistics company india"],
        ["third party logistics services india", "3pl logistics services india"],
        ["third party logistics provider india", "3pl service provider india"],
        ["best 3pl logistics company india", "top 3pl companies india"],
        ["leading 3pl companies india", "3pl transportation services india"],
        ["3pl warehousing services india", "3pl supply chain services india"],
        ["third party logistics provider pune", "3pl logistics provider pune"],
        ["end to end 3pl services india", "third party logistics solutions india"],
        ["3pl freight services india", "3pl cargo transportation india"],
        ["3pl distribution services india", "3pl warehouse management india"],
        ["reliable 3pl company india", "professional 3pl logistics provider india"],
        ["3pl logistics partner india", "3pl transportation company india"],
        ["third party logistics solutions provider india", "Third Party Logistics Company in India"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Integrated 3PL Coordination",
            WhyChoosedescription: "SSK Logistic supports businesses that want to coordinate multiple logistics functions through one external logistics arrangement. Transportation, freight movement, cargo distribution, warehouse transfers, and related supply chain activities can be organized according to the business's operational requirements."
        },
        {
            WhyChooseheading: "Transportation and Freight Support",
            WhyChoosedescription: "Transportation is a central part of third-party logistics operations, particularly for businesses managing suppliers and customers across multiple regions. SSK Logistic provides road freight and cargo transportation coordination for local, regional, and interstate supply chain movement."
        },
        {
            WhyChooseheading: "Warehouse-Linked Logistics",
            WhyChoosedescription: "Businesses often need transportation to work together with warehouse operations and distribution schedules. SSK Logistic supports warehouse-related movement, including transfers between storage facilities, suppliers, manufacturing units, distribution centers, and commercial destinations."
        },
        {
            WhyChooseheading: "National Distribution Connectivity",
            WhyChoosedescription: "Supply chains frequently extend across several states and major commercial markets. SSK Logistic assists businesses with third-party logistics transportation connecting Pune and other origin locations with destination markets throughout India."
        },
        {
            WhyChooseheading: "Support for Recurring Logistics",
            WhyChoosedescription: "Companies managing regular dispatches can require consistent coordination rather than isolated transportation arrangements. SSK Logistic supports recurring 3PL requirements for businesses handling repeated freight, cargo, distribution, and warehouse movement across established routes."
        },
        {
            WhyChooseheading: "Flexible Supply Chain Assistance",
            WhyChoosedescription: "Every business has different logistics volumes, warehouse locations, delivery schedules, and distribution patterns. SSK Logistic provides flexible third-party logistics support that can be aligned with commercial, industrial, manufacturing, and distribution operations."
        },
        {
            WhyChooseheading: "Commercial and Industrial Coverage",
            WhyChoosedescription: "Third-party logistics requirements can range from commercial product distribution to industrial freight movement and manufacturing supply chains. SSK Logistic supports different cargo and transportation requirements while coordinating movement between suppliers, facilities, warehouses, and destination markets."
        },
        {
            WhyChooseheading: "Structured Logistics Planning",
            WhyChoosedescription: "SSK Logistic approaches 3PL operations through organized transportation and distribution planning, helping businesses coordinate connected logistics activities across multiple locations. The focus remains on practical movement planning, route coordination, cargo handling requirements, and delivery scheduling."
        }
    ]

};











const faqData = [
    {
        question: "What third party logistics services does SSK Logistic provide in India?",
        answer: "SSK Logistic supports businesses with transportation and logistics coordination for commercial and industrial goods, helping organize cargo movement between suppliers, warehouses, businesses, distribution points, and other destinations across India."
    },
    {
        question: "Can SSK Logistic manage transportation between different cities in India?",
        answer: "Yes, businesses can coordinate goods transportation between major locations across India, including routes connecting Pune, Mumbai, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, Nashik, Nagpur, and other destinations."
    },
    {
        question: "What types of businesses can use SSK Logistic as a third party logistics provider?",
        answer: "Manufacturers, distributors, wholesalers, suppliers, retailers, warehouses, and other businesses with regular cargo movement requirements can discuss suitable third party logistics and transportation arrangements."
    },
    {
        question: "What types of goods can SSK Logistic handle for businesses?",
        answer: "Depending on the transportation and handling requirements, suitable consignments may include raw materials, finished products, commercial inventory, machinery, equipment, packaged goods, industrial supplies, and other business cargo."
    },
    {
        question: "Can SSK Logistic support businesses with recurring logistics requirements?",
        answer: "Companies with ongoing transportation needs can discuss recurring arrangements based on shipment frequency, regular routes, cargo volumes, vehicle requirements, pickup schedules, and expected delivery timelines."
    },
    {
        question: "How does SSK Logistic plan third party logistics transportation?",
        answer: "Logistics planning takes into account the pickup location, destination, cargo characteristics, shipment quantity, weight, dimensions, loading requirements, vehicle capacity, route, and preferred delivery schedule."
    },
    {
        question: "Can SSK Logistic coordinate interstate logistics transportation?",
        answer: "Interstate cargo movement can be organized between different regions of India, with transportation plans developed according to the specific origin, destination, cargo requirements, vehicle needs, and business delivery schedule."
    },
    {
        question: "Can manufacturers use SSK Logistic for supply and distribution movement?",
        answer: "Manufacturers can use transportation support for moving raw materials toward production locations and finished products toward warehouses, distributors, customers, or other business destinations."
    },
    {
        question: "Can third party logistics arrangements be customized for different companies?",
        answer: "Yes, logistics arrangements can be discussed according to individual business requirements, including shipment frequency, routes, cargo volume, vehicle capacity, pickup points, delivery destinations, loading conditions, and scheduling needs."
    },
    {
        question: "What information should I provide to enquire about SSK Logistic services in India?",
        answer: "Businesses can share their pickup and delivery locations, cargo type, approximate quantity or weight, shipment frequency, vehicle requirement, loading details, and preferred delivery schedule to discuss an appropriate logistics transportation solution."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Arvind Malhotra",
        feedback: "Our company needed regular transportation support between production and distribution locations in different states. SSK Logistic understood our movement requirements and helped coordinate the shipments according to our operating schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Nandini Rao",
        feedback: "We approached SSK Logistic for interstate movement of commercial inventory. Their team considered our pickup, destination, cargo quantity, and vehicle requirements, making the logistics coordination easier for our business.",
        rating: 5
    }
];











    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Third Party Logistics Company in India",
  "image": "https://ssklogistics.in/assets/images/third-party-logistics-company-in-india.webp",
  "description": "SSK Logistics provides Third Party Logistics Company in India solutions for businesses that need coordinated transportation, freight movement, cargo handling support and supply chain logistics without managing every transportation activity internally. Third party logistics company India requirements can include outsourced logistics coordination for manufacturers, distributors, wholesalers, retailers, e-commerce businesses and industrial organizations operating across multiple locations. As a 3PL logistics company India, SSK Logistics can support businesses with transportation planning, vehicle coordination, goods movement, freight management and distribution-related logistics requirements. Third party logistics services India can be structured around shipment frequency, cargo type, delivery locations, vehicle requirements and business schedules, while 3PL logistics services India can assist companies with recurring transportation and supply chain movement. A third party logistics provider India can coordinate transportation activities between suppliers, factories, warehouses, distribution centers and customer destinations. SSK Logistics supports practical 3PL arrangements for businesses requiring local, regional and interstate goods transportation, including commercial cargo, industrial materials, finished products and regular business consignments. Outsourced logistics coordination can help businesses organize freight movement, warehouse transfers, distribution transportation and route planning through a centralized service arrangement. Third party logistics solutions can also support growing businesses that require scalable transportation coordination across different cities and states. SSK Logistics focuses on flexible 3PL logistics support designed around business requirements, shipment volumes, destination networks and transportation schedules across India.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Logistics Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/third-party-logistics-company-in-india"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Third Party Logistics Company in India | 3PL Logistics & Transportation Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers third party logistics and 3PL services in India covering transportation coordination, freight movement, cargo logistics and supply chain support for businesses."
  />

  <meta
    name="keywords"
    content="Third Party Logistics Company in India, third party logistics company India, 3PL logistics company India, third party logistics services India, 3PL logistics services India, third party logistics provider India, 3PL logistics provider India, third party logistics company in India, 3PL company India, 3PL services India, third party logistics services in India, third party logistics provider in India, 3PL service provider India, third party logistics solutions India, 3PL logistics solutions India, outsourced logistics services India, outsourced transportation services India, logistics outsourcing company India, third party transportation services India, third party freight services India, third party cargo logistics India, 3PL transportation services India, 3PL freight services India, 3PL cargo services India, supply chain logistics India, supply chain management services India, contract logistics India, commercial logistics services India, industrial logistics services India, business logistics services India, freight logistics company India, cargo logistics company India, transportation logistics India, warehouse logistics India, distribution logistics India, B2B logistics services India, interstate logistics services India, nationwide logistics services India, logistics management company India"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thirdpartylogisticcompany;